/** AppSync Events channel pinged when a deployment of the stage finishes. */
export const DEPLOYMENT_EVENT_CHANNEL = "deployments/latest";
